import React from 'react'
import {useHistory} from "react-router"
import {useTranslation} from "react-i18next"

import {IonButton, IonButtons, IonIcon, IonItem, IonItemOptions, IonLabel} from "@ionic/react"
import {keyOutline, keySharp, link, lockClosedOutline, lockClosedSharp} from "ionicons/icons"

import {LockingSystemPermission as ItemType} from "../../types/LockingSystemPermission"

import ListItemOptionDelete from "./ListItemOptionDelete"
import IconLockingSystemPermission from "../common/Icons/LockingSystemPermission"
import BadgeLockingSystemPermissionType from "../common/Badges/BadgeLockingSystemPermissionType"

import {useAuth} from "../../contexts/AuthContext";
import NumberFormat from "../common/Text/NumberFormat";

interface itemProps {
    item: ItemType
}

const ListItem: React.FC<itemProps> = ({ item }) => {

    const { t } = useTranslation()
    const {isAccountAdmin} = useAuth()

    const minButtonWidth: string = '95px'

    const
        history = useHistory(),
        keysCount: number  = item.counts?.keys  || 0,
        locksCount: number = item.counts?.locks || 0

    const goToSegment = (ev: any, itemId: number, segment: string) => {
        ev.preventDefault()
        ev.stopPropagation()

        history.push('/locking-system-permissions/' + itemId + '/' + segment)
    }

    const itemBadge = () => {
        if (item.lockingSystemPermissionType) {
            return (<BadgeLockingSystemPermissionType item={item.lockingSystemPermissionType} />)
        }
    }

    return (
        <>
            <IonItem button className={item.isHiddenByDefault ? 'hidden-by-default' : ''}
                     detail={true} routerLink={"/locking-system-permissions/" + item.id + '/view'} slot="start">
                <IconLockingSystemPermission slot="start" />
                <IonLabel>
                    {item.name}
                    {item.lockingSystemZone &&
                        <span style={{ 'fontWeight': 200 }}>
                        &nbsp;- {item.lockingSystemZone.name}
                    </span>
                    }
                    <p>{item.description || <i>{'(' + t('common.no_description') + ')'}</i>}</p>
                </IonLabel>
                {itemBadge()}
                <IonButtons className="ion-hide-sm-down" slot="end">
                    <span style={{ 'minWidth': minButtonWidth }}>
                    <IonButton color={keysCount ? "medium" : "light"} fill="clear"
                               onClick={ (ev) => goToSegment(ev, item.id, 'keys') }
                               shape="round" size="large" style={{ 'fontSize': '1rem' }}>
                        <IonIcon slot="start" ios={keyOutline} md={keySharp} />
                        <NumberFormat number={keysCount} />
                    </IonButton>
                    </span>
                    <span style={{ 'minWidth': minButtonWidth }}>
                    <IonButton color={locksCount ? "medium" : "light"} fill="clear"
                               onClick={ (ev) => goToSegment(ev, item.id, 'locks') }
                               shape="round" size="large" style={{ 'fontSize': '1rem' }}>
                        <IonIcon slot="start" ios={lockClosedOutline} md={lockClosedSharp} />
                        {(locksCount === 1 && item.individualLockId) ? (
                            <IonIcon color="bc-yellow" icon={link} />
                        ) : (
                            <NumberFormat number={locksCount} />
                        )}
                    </IonButton>
                    </span>
                </IonButtons>
            </IonItem>
            <IonItemOptions slot="end">
                {(isAccountAdmin() && item.options?.isRemovableFromKey && keysCount === 0 && locksCount === 0) &&
                    <ListItemOptionDelete item={item} />
                }
            </IonItemOptions>
        </>
    )
}

export default ListItem